module.exports = __webpack_public_path__ + "img/aa-desktop-hover.17b78c3d.png";